import React from "react";
import "./Print_Media_Why_Choose_Us_list_card.css";

function Print_Media_Why_Choose_Us_list_card(props) {
  return (
    <>
      <section className="Print_Media_Why_Choose_Us_list_card">
        <div className="row">
          <div className="col-xl-2 col-lg-2 col-md-3 col-3">
            <div className="img_holder">
              <img
                className="Why_Choose_Us_img"
                src={
                  props?.imgSrc
                }
                alt="Why_Choose_Us_img"
              />
            </div>
          </div>

          <div className="col-xl-10 col-lg-10 col-md-9 col-9">
            <div className="text_holder">
              <h5>{props?.title}</h5>

              <p>
                {props?.subtext}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Print_Media_Why_Choose_Us_list_card;
